export default function SET_UPDATE_CANDIDATE(state, candidateData) {
    state.updatedCandidate = candidateData;
}